import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';

/**
 * PhoneTopStrip — Departure Board top strip for phone (viewport < 768px).
 * 52px tall, brand left, MENU button right. Tapping MENU slides down a
 * full-width nav sheet covering the page body. Pure presentational + local
 * useState for the open/close — no router push, no modal library.
 */
const routeKey = (pathname) => {
  if (pathname === '/' || pathname === '' || pathname === '/dashboard') return 'dashboard';
  if (pathname.startsWith('/dashboard/feedback')) return 'feedback';
  if (pathname.startsWith('/dashboard/supervisor-information')) return 'supervisors';
  if (pathname.startsWith('/dashboard/manage-supervisors')) return 'manage';
  if (pathname.startsWith('/fame')) return 'fame';
  if (pathname.startsWith('/sms-blast')) return 'sms';
  if (pathname.startsWith('/gps-tracking')) return 'gps';
  return '';
};

export default function PhoneTopStrip() {
  const { pathname } = useLocation();
  const { isAdmin } = useAdmin();
  const active = routeKey(pathname);
  const [open, setOpen] = useState(false);

  // Close on route change
  useEffect(() => { setOpen(false); }, [pathname]);

  // Lock body scroll while sheet open
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  const allLinks = [
    { to: '/', key: 'dashboard', label: 'DASHBOARD', adminOnly: false },
    { to: '/dashboard/feedback', key: 'feedback', label: 'ALL FEEDBACK', adminOnly: true },
    { to: '/dashboard/supervisor-information', key: 'supervisors', label: 'SUPERVISORS', adminOnly: true },
    { to: '/dashboard/manage-supervisors', key: 'manage', label: 'DIRECTORY', adminOnly: true },
    { to: '/fame', key: 'fame', label: 'FAME · HR', adminOnly: true },
    { to: '/sms-blast', key: 'sms', label: 'SMS BLAST', adminOnly: true },
    { to: '/gps-tracking', key: 'gps', label: 'GPS TRACKING', adminOnly: true },
  ];
  const links = allLinks.filter((l) => !l.adminOnly || isAdmin);

  return (
    <>
      <header className="db-top-phone">
        <div className="brand">
          <img src="/ixora_logo_clean.png" alt="Ixora Group" className="db-brand-logo" />
          <span className="sep">·</span><span className="product">FEEDBACK</span>
        </div>
        <button
          type="button"
          className={`menu-btn${open ? ' is-open' : ''}`}
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls="db-phone-sheet"
        >
          {open ? 'CLOSE' : 'MENU'}
        </button>
      </header>
      {open && (
        <nav id="db-phone-sheet" className="db-sheet" aria-label="Primary">
          {links.map((l) => (
            <Link key={l.key} to={l.to} className={active === l.key ? 'on' : ''}>
              {l.label}
            </Link>
          ))}
        </nav>
      )}
    </>
  );
}
